/**
 * 請求一覧: 行ごとの PDF アップロード（非表示 file + ボタンでファイル選択 → フォーム送信）
 */
window.addEventListener('DOMContentLoaded', function () {
    const pageRoot = document.getElementById('js-billings-list');
    if (!pageRoot) {
        return;
    }

    document.querySelectorAll('.billing-upload-form').forEach((uploadForm) => {
        const fileInput = uploadForm.querySelector('input[type="file"][name="billing_pdf"]');
        const uploadButton = uploadForm.querySelector('.js-btn-upload');
        if (!fileInput || !uploadButton) {
            return;
        }

        uploadButton.addEventListener('click', (clickEvent) => {
            clickEvent.preventDefault();
            fileInput.click();
        });

        fileInput.addEventListener('change', () => {
            const selectedFile = fileInput.files[0];
            if (!selectedFile) {
                return;
            }

            const defaultLabel = uploadButton.getAttribute('data-label-default') ?? uploadButton.textContent;
            const loadingLabel = uploadButton.getAttribute('data-label-loading') ?? defaultLabel;

            uploadButton.disabled = true;
            uploadButton.textContent = loadingLabel;

            uploadForm.submit();
        });
    });

    /**
     * 請求詳細ボタンをクリックしたら新しいウィンドウを開く
     */
    document.querySelectorAll('.js-open-window').forEach(function (openWindowButton) {
        openWindowButton.addEventListener('click', function (e) {
            e.preventDefault();
            // 現在のブラウザの表示幅・高さを取得
            const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
            window.open(e.currentTarget.href, 'billingDetailWindow', `width=${width},height=${height},scrollbars=yes`);
        });
    });
});
